import { defineMessages } from 'react-intl'

export default defineMessages({
  RedirectedTo: {
    id: 'components.PaymentMethods.App.RedirectedTo',
    defaultMessage: 'You are going to be redirected to',
    description: '请修改',
  },
  Processing: {
    id: 'components.PaymentMethods.App.Processing',
    defaultMessage: 'Processing...',
    description: '请修改',
  },
  BacktoRetry: {
    id: 'components.PaymentMethods.App.BacktoRetry',
    defaultMessage: 'Retry',
    description: '请修改',
  },
  CashierPage:{
    id: 'components.PaymentMethods.CashierPage',
    defaultMessage:' cashier page',
    description:'请修改'
  },
  HighlightAliPayName:{
    id: 'components.PaymentMethods.HighlightAliPayName',
    defaultMessage:'AliPay',
    description:'请修改'
  },
  ProcessingDescription:{
    id: 'components.PaymentMethods.ProcessingDescription',
    defaultMessage:'Please continue to your transaction on',
    description:'请修改'
  },
  Pay: {
    id: 'components.PaymentMethods.AddNewCard.Pay',
    defaultMessage: 'Pay',
    description: '请修改',
  },
})
